<template>
  <div class="box-container">
    <div
      class="teacher-item"
      v-for="item in teacherList"
      :key="item.id"
      @mouseenter="handleShowInfo(item)"
      @mouseleave="handleHideInfo(item)"
      @click="toInfo(item)">
      <img :src="item.teacherPropagateUrl" alt="">
      <div v-show="showInfo && showId === item.id" class="text-box">
        <p class="name" v-html="item.teacherName"></p>
        <p class="desc" v-html="item.teacherIntroduce"></p>
        <!-- <p class="ql-editor" v-html="item.teacherAchievement"></p> -->
      </div>
      <div class="info" v-show="!item.showInfo">
          <p v-html="item.teacherName"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      teacherList: [],
      showInfo: false,
      showId: ''
    }
  },
  watch: {
    list(val) {
      this.teacherList = val
    }
  },
  mounted() {
    this.teacherList = this.list
  },
  methods: {
    toInfo(data) {
      this.$router.push({
        path: '/teacherIntroduce',
        query: {
          id: data.id,
          name: this.$route.query.searchValue
        }
      })
    },
    handleShowInfo(info) {
      info.showInfo = true
      this.showInfo = true
      this.showId = info.id
    },
    handleHideInfo(info) {
      info.showInfo = false
      this.showInfo = false
      this.showId = ''
    }
  }
}
</script>

<style lang="scss">
.box-container {
  width: 1084px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .teacher-item {
    width: 250px;
    height: 225px;
    margin-top: 26px;
    margin-left: 28px;
    position: relative;
    cursor: pointer;
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    img {
      width: 250px;
      height: 190px;
    }
    .info {
      p {
        width: 100%;
        position: absolute;
        bottom: 0;
        height: 35px;
        line-height: 35px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        background-color: rgba(27, 134, 255, .6);
      }
    }
    .text-box {
      position: absolute;
      top: 0;
      width: 250px;
      height: 225px;
      background-color: rgba(27, 134, 255, .8);
      padding: 26px 20px;
      box-sizing: border-box;
      p {
        color: #fff;
        font-size: 14px;
        line-height: 23px;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:5
      }
      .name {
        text-align: center;
        font-weight: bold;
      }
      .desc {
        margin: 30px 0 20px 0;
        p {
          span {
            color: #fff !important;
          }
          img {
            height: 50px;
          }
        }
      }
    }
  }
}
</style>
